import { QueryClient } from "@tanstack/react-query";
import { getRetryDelayMs, shouldRetryRequest } from "@/shared/retryPolicy.ts";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: shouldRetryRequest,
      retryDelay: getRetryDelayMs,
    },
  },
});
